import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { displaySnackBar } from '../../common/displaySnackbar';
import { SET_USER_PERMISSIONS } from '../../graphql/role/mutation';
import {
  SetUserPermissions,
  SetUserPermissionsVariables,
} from '../../graphql/role/types/SetUserPermissions';

export const useSetUserPermissions = () => {
  const client = useApolloClient();
  return useMutation<SetUserPermissions, SetUserPermissionsVariables>(
    SET_USER_PERMISSIONS,
    {
      onCompleted: (data) => {
        if (data?.setUserPermissions)
          displaySnackBar(client, {
            type: 'SUCCESS',
            message: 'Mise à jour effectuée avec succès',
            isOpen: true,
          });
      },
    },
  );
};
